export default __webpack_public_path__ + "static/media/home_mobile.6ed197d2.svg";